import * as server from '../entries/pages/admin/legislation/_id_integer_/_page.server.ts.js';

export const index = 26;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/admin/legislation/_id_integer_/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/admin/legislation/[id=integer]/+page.server.ts";
export const imports = ["_app/immutable/nodes/26.BU_hCZLL.js","_app/immutable/chunks/Bzak7iHL.js","_app/immutable/chunks/CnGaPG_y.js","_app/immutable/chunks/DIeogL5L.js","_app/immutable/chunks/BBilxCvN.js","_app/immutable/chunks/7JdHMB9Z.js","_app/immutable/chunks/BqhvobEz.js","_app/immutable/chunks/B764PkgB.js","_app/immutable/chunks/BRzKQYUk.js","_app/immutable/chunks/CvyiGclN.js","_app/immutable/chunks/Dsy9VFq4.js","_app/immutable/chunks/CAN0e4T3.js"];
export const stylesheets = ["_app/immutable/assets/26.7k0Ho6m0.css"];
export const fonts = [];
